var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text0, _text1, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _text40, _text41, _text42, _g41, _g42, _text43, _text44, _text45, _text46, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _text56, _text57, _text58, _text59, _text60, _text61, _text62, _text63, _text64, _text65, _text66, _g43, _g44, _text67, _text68, _text69, _text70, _text71, _text72, _text73, _text74, _text75, _g45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWdScreen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1801.616,
    height: 716.968,
    viewBox: "0 0 1801.616 716.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5149",
    "data-name": "Rectangle 5149",
    width: 45,
    height: 38,
    transform: "translate(-0.133 0.462)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13529",
    "data-name": "Group 13529",
    transform: "translate(-89.966 -1024.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13473",
    "data-name": "Group 13473",
    transform: "translate(14 195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WD-components-default",
    transform: "translate(75.966 829.574)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_46446",
    "data-name": "Path 46446",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 704.8770141601562 716.0419921875 L 7.525384426116943 716.0419921875 C 3.651566028594971 716.0419921875 0.5000205636024475 713.479248046875 0.5000205636024475 710.3292846679688 L 0.5000205636024475 6.212814331054688 C 0.5000205636024475 3.062723398208618 3.651566028594971 0.4999960958957672 7.525384426116943 0.4999960958957672 L 704.8770141601562 0.4999960958957672 C 708.7508544921875 0.4999960958957672 711.9024047851562 3.062723398208618 711.9024047851562 6.212814331054688 L 711.9024047851562 710.3292846679688 C 711.9024047851562 713.479248046875 708.7508544921875 716.0419921875 704.8770141601562 716.0419921875 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.525390625 1 C 3.92730712890625 1 1 3.33843994140625 1 6.21270751953125 L 1 710.3291625976562 C 1 713.2035522460938 3.92730712890625 715.5419921875 7.525390625 715.5419921875 L 704.8770141601562 715.5419921875 C 708.47509765625 715.5419921875 711.4024047851562 713.2035522460938 711.4024047851562 710.3291625976562 L 711.4024047851562 6.21270751953125 C 711.4024047851562 3.33843994140625 708.47509765625 1 704.8770141601562 1 L 7.525390625 1 M 7.525390625 0 L 704.8770141601562 0 C 709.0330810546875 0 712.4024047851562 2.78155517578125 712.4024047851562 6.21270751953125 L 712.4024047851562 710.3291625976562 C 712.4024047851562 713.7604370117188 709.0330810546875 716.5419921875 704.8770141601562 716.5419921875 L 7.525390625 716.5419921875 C 3.36920166015625 716.5419921875 0 713.7604370117188 0 710.3291625976562 L 0 6.21270751953125 C 0 2.78155517578125 3.36920166015625 0 7.525390625 0 Z",
    stroke: "none",
    fill: "#57585a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2",
    transform: "translate(25.016 304.065)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2",
    x1: 424.645,
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2",
    transform: "translate(498.45 304.065)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2",
    x1: 182.302,
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-3",
    transform: "translate(473.966 322.967)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-3",
    y2: 188.549,
    transform: "translate(0)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-4",
    transform: "translate(473.966 557.404)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-4",
    y2: 133.723,
    transform: "translate(0)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-5",
    transform: "translate(498.45 536.727)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-5",
    x1: 182.302,
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-6",
    transform: "translate(25.016 536.727)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-6",
    x1: 424.645,
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10721",
    "data-name": "Group 10721",
    transform: "translate(40.644 51.697)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 6.083,
    cy: 6.058,
    rx: 6.083,
    ry: 6.058,
    transform: "translate(10.544)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 15.176,
    y2: 13.119,
    transform: "translate(21.063 10.711)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5191",
    "data-name": "Path 5191",
    d: "M27.98,20.47H16.09v6.409H27.98",
    transform: "translate(-16.09 -17.61)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 6.083,
    cy: 6.058,
    rx: 6.083,
    ry: 6.058,
    transform: "translate(37.492)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5192",
    "data-name": "Path 5192",
    d: "M55.36,26.879H67.238V20.47H55.36",
    transform: "translate(-7.035 -17.61)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Valve_Icon",
    "data-name": "Valve Icon",
    transform: "translate(40.644 340.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5189",
    "data-name": "Path 5189",
    d: "M54.988,202.745V175.572a.214.214,0,0,0-.364-.142l-15.2,13.587a.2.2,0,0,0,0,.3l15.2,13.587a.217.217,0,0,0,.364-.142Z",
    transform: "translate(-9.435 -175.362)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5190",
    "data-name": "Path 5190",
    d: "M26.74,175.573v27.173a.214.214,0,0,0,.364.142L42.3,189.3a.2.2,0,0,0,0-.3L27.1,175.419a.217.217,0,0,0-.364.142Z",
    transform: "translate(-12.105 -175.363)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4660",
    "data-name": "Rectangle 4660",
    width: 14.637,
    height: 6.409,
    transform: "translate(14.637 17.007) rotate(180)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4661",
    "data-name": "Rectangle 4661",
    width: 13.445,
    height: 6.409,
    transform: "translate(60.203 17.007) rotate(180)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Pump_Icon",
    "data-name": "Pump Icon",
    transform: "translate(48.17 563.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5193",
    "data-name": "Path 5193",
    d: "M65.48,343.062h-1.3V321.744a18.887,18.887,0,0,0-23.509-18.209v-3.06h1.3a2.386,2.386,0,0,0,2.392-2.373V295.43H22.72V298.1a2.378,2.378,0,0,0,2.392,2.373h1.3v21.318A18.887,18.887,0,0,0,49.924,340v3.06h-1.3a2.386,2.386,0,0,0-2.392,2.373v2.673H67.872v-2.673a2.378,2.378,0,0,0-2.392-2.373Z",
    transform: "translate(-22.72 -295.43)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 18.908,
    cy: 18.763,
    rx: 18.908,
    ry: 18.763,
    transform: "translate(3.662 7.563)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 9.331,
    cy: 9.306,
    rx: 9.331,
    ry: 9.306,
    transform: "translate(13.238 17.02)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Blower_Icon",
    "data-name": "Blower Icon",
    transform: "translate(492.166 338.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5195",
    "data-name": "Path 5195",
    d: "M419.06,193.939a22.579,22.579,0,1,1-21.894-17.049",
    transform: "translate(-374.59 -176.89)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "fan_blower",
    "data-name": "fan blower"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5194",
    "data-name": "Path 5194",
    d: "M397.176,222.062a22.554,22.554,0,0,0,22.536-22.576,22.885,22.885,0,0,0-.682-5.533h12V176.91h-33.9a22.554,22.554,0,0,0-22.536,22.576,22.885,22.885,0,0,0,.682,5.533",
    transform: "translate(-374.59 -176.91)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5196",
    "data-name": "Path 5196",
    d: "M400.681,211.388a3.676,3.676,0,0,0,.1-4.258l-2.947-4.908a3.369,3.369,0,0,0-.677-1.058,2.852,2.852,0,0,0,1.618-1.81,3.709,3.709,0,0,0,.953.676l4.691,3.225a3.563,3.563,0,0,0,4.2.1,6.491,6.491,0,0,0,1.029-.918,9.211,9.211,0,0,0,2.471-4.551,3.5,3.5,0,0,0-.376-2.881,1.672,1.672,0,0,0-1.217-.612,18.958,18.958,0,0,0-10.724,2.754,3.556,3.556,0,0,0-.966.65,2.822,2.822,0,0,0-.665-1.326l-.025-.026a2.748,2.748,0,0,0-.941-.637,3.857,3.857,0,0,0,.589-.892l3.186-4.755a3.668,3.668,0,0,0,.1-4.258,6.535,6.535,0,0,0-.9-1.045,9.114,9.114,0,0,0-4.49-2.512,3.368,3.368,0,0,0-2.847.382,1.72,1.72,0,0,0-.6,1.237,19.585,19.585,0,0,0,2.709,10.862,4.156,4.156,0,0,0,.527.854,2.741,2.741,0,0,0-1.355.676,2.789,2.789,0,0,0-.727,1.3,3.726,3.726,0,0,0-.928-.65l-4.691-3.225a3.563,3.563,0,0,0-4.2-.1,6.491,6.491,0,0,0-1.028.918,9.211,9.211,0,0,0-2.471,4.551,3.5,3.5,0,0,0,.376,2.881,1.719,1.719,0,0,0,1.217.612A19,19,0,0,0,392.39,199.9a3.277,3.277,0,0,0,.978-.676,2.737,2.737,0,0,0,.652,1.237l.025.025a2.763,2.763,0,0,0,1.543.778,4.686,4.686,0,0,0-.6.88,19.574,19.574,0,0,0-3.248,10.722,1.691,1.691,0,0,0,.539,1.262,3.35,3.35,0,0,0,2.822.523,9.011,9.011,0,0,0,4.6-2.269,6.332,6.332,0,0,0,.953-.994Z",
    transform: "translate(-373.226 -175.558)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Heater_Icon",
    "data-name": "Heater Icon",
    transform: "translate(492.166 564.964)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5270",
    "data-name": "Path 5270",
    d: "M27.76,38.622V35.25a2.733,2.733,0,0,1,2.738-2.71H40.643a3.159,3.159,0,0,0,0-6.307H32.149l.362,0H10.854a3.159,3.159,0,0,1,0-6.307H40.643a3.159,3.159,0,0,0,0-6.306H10.909a3.073,3.073,0,0,1-2.966-3.154,3.073,3.073,0,0,1,2.966-3.154H40.621a3.074,3.074,0,0,0,2.967-3.154A3.074,3.074,0,0,0,40.621,1H6.956A6.153,6.153,0,0,0,1,7.331V26.209a6.152,6.152,0,0,0,5.956,6.33H14.02a2.733,2.733,0,0,1,2.738,2.71v3.373",
    transform: "translate(0.006 0.314)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "VAG-Default",
    "data-name": "Group 13510",
    transform: "translate(8.5 11.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Air Gap Valve"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4946",
    "data-name": "Rectangle 4946",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(124.534 325.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "VAG",
    transform: "translate(143.034 349.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VAG")))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "VCON-Default",
    "data-name": "Group 13511",
    transform: "translate(8.5 11.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Condenser Valve"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4947",
    "data-name": "Rectangle 4947",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(235.534 325.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "VCON",
    transform: "translate(248.034 349.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VCON")))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "VCW-Default",
    "data-name": "Group 13513",
    transform: "translate(8.5 18.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Cold Water Valve"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4948",
    "data-name": "Rectangle 4948",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(124.534 387.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "VCW",
    transform: "translate(141.034 411.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VCW")))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "VSR-Default",
    "data-name": "Group 13514",
    transform: "translate(8.5 18.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Salt Regeneration Valve"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4949",
    "data-name": "Rectangle 4949",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(235.534 387.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "VSR",
    transform: "translate(255.034 411.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VSR")))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "VHW-Default",
    "data-name": "Group 13516",
    transform: "translate(12.5 24.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Hot Water Valve"), /*#__PURE__*/React.createElement("text", {
    id: "SBAR",
    transform: "translate(128.034 475.426)",
    fill: "#f1f2f2",
    fontSize: 22,
    fontFamily: "Bitstream Vera Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SBAR")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4951",
    "data-name": "Rectangle 4951",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(120.534 450.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "VHW",
    transform: "translate(137.034 475.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VHW")))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "VROW-Default",
    "data-name": "Group 13528",
    transform: "translate(11.5 24.5)"
  }, /*#__PURE__*/React.createElement("title", null, "RO Water Valve"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4953",
    "data-name": "Rectangle 4953",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(232.534 450.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "VROW",
    transform: "translate(243.034 475.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VROW")))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "PCIRC-Default",
    "data-name": "Group 13518",
    transform: "translate(12.5 6.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Circulation Pump"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4900",
    "data-name": "Rectangle 4900",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(120.534 559.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "PCIRC",
    transform: "translate(131.034 583.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PCIRC")))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "PDRA-Default",
    "data-name": "Group 13519",
    transform: "translate(11.5 6.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Evacuation Pump"), /*#__PURE__*/React.createElement("text", {
    id: "SBAR-2",
    "data-name": "SBAR",
    transform: "translate(237.034 583.426)",
    fill: "#f1f2f2",
    fontSize: 22,
    fontFamily: "Bitstream Vera Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SBAR")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4956",
    "data-name": "Rectangle 4956",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(232.534 559.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "PDRA",
    transform: "translate(245.034 583.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDRA")))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "PAG-Default",
    "data-name": "Group 13520",
    transform: "translate(10.5 6.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Air Gap Pump"), /*#__PURE__*/React.createElement("text", {
    id: "SBAR-3",
    "data-name": "SBAR",
    transform: "translate(348.034 583.426)",
    fill: "#f1f2f2",
    fontSize: 22,
    fontFamily: "Bitstream Vera Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SBAR")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4958",
    "data-name": "Rectangle 4958",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(344.534 559.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "PAG",
    transform: "translate(364.034 583.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PAG")))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "HW-Default",
    "data-name": "Group 13527",
    transform: "translate(10.5 13.5)"
  }, /*#__PURE__*/React.createElement("title", null, "HW Water Heater"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4905",
    "data-name": "Rectangle 4905",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(567.534 621.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "HW",
    transform: "translate(590.034 645.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HW")))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "SCHF-Default",
    "data-name": "Group 13495",
    transform: "translate(9.5 1.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Chamber Full Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4935",
    "data-name": "Rectangle 4935",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(345.534 39.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SCHF",
    transform: "translate(359.034 62.426)",
    fill: "#5f6a7b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SCHF")))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "VRAD-Default",
    "data-name": "Group 13515",
    transform: "translate(10.5 18.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Rinse Aid Dispenser Valve"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5044",
    "data-name": "Rectangle 5044",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(344.534 387.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "VRAD",
    transform: "translate(357.034 411.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VRAD")))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "PCF-Default",
    "data-name": "Group 13521",
    transform: "translate(12.5 13.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Chemical Fill Pump"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5045",
    "data-name": "Rectangle 5045",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(120.534 621.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "PCF",
    transform: "translate(141.034 645.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PCF")))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "PCD-Default",
    "data-name": "Group 13522",
    transform: "translate(11.5 13.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Chemical Dosing Pump"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5046",
    "data-name": "Rectangle 5046",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(232.534 621.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "PCD",
    transform: "translate(252.034 645.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PCD")))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "BDRY-Default",
    "data-name": "Group 13525",
    transform: "translate(10.5 24.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Dryer Blower Motor"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5003",
    "data-name": "Rectangle 5003",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(567.534 450.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "BDRY",
    transform: "translate(581.034 474.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BDRY")))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "HD-Default",
    "data-name": "Group 13526",
    transform: "translate(10.5 6.5)"
  }, /*#__PURE__*/React.createElement("title", null, "HD Dryer Heater"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5004",
    "data-name": "Rectangle 5004",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(567.534 559.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "HD",
    transform: "translate(592.034 583.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HD")))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "STAR-Default",
    "data-name": "Group 13496",
    transform: "translate(9.5 1.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Top Arm RPM Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4811",
    "data-name": "Rectangle 4811",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(456.534 39.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "STAR",
    transform: "translate(471.034 62.426)",
    fill: "#5f6a7b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "STAR")))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "SBAR-Default",
    "data-name": "Group 13497",
    transform: "translate(8.5 1.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Bottom Arm RPM Switch"), /*#__PURE__*/React.createElement("text", {
    id: "SBAR-4",
    "data-name": "SBAR",
    transform: "translate(573.034 63.426)",
    fill: "#f1f2f2",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 22,
    fontFamily: "Bitstream Vera Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SBAR")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4816",
    "data-name": "Rectangle 4816",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(568.534 39.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SBAR-5",
    "data-name": "SBAR",
    transform: "translate(582.034 62.426)",
    fill: "#5f6a7b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SBAR")))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "VLCS-Default",
    "data-name": "Group 13512",
    transform: "translate(10.5 11.5)"
  }, /*#__PURE__*/React.createElement("title", null, "LCS Air Valve"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5022",
    "data-name": "Rectangle 5022",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(344.534 325.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "VLCS",
    transform: "translate(358.034 349.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VLCS")))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "SCHO-Default",
    "data-name": "Group 13493",
    transform: "translate(11.5 1.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Chamber Overflow Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4933",
    "data-name": "Rectangle 4933",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(121.534 39.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SCHO",
    transform: "translate(133.034 62.426)",
    fill: "#5f6a7b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SCHO")))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "SCHE-Default",
    "data-name": "Group 13494",
    transform: "translate(9.5 1.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Chamber Empty Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4934",
    "data-name": "Rectangle 4934",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(234.534 39.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SCHE",
    transform: "translate(248.034 62.426)",
    fill: "#5f6a7b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SCHE")))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "SAGF-Default",
    "data-name": "Group 13500",
    transform: "translate(9.5 3.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Air Gap Full Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4943",
    "data-name": "Rectangle 4943",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(345.534 104.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SAGF",
    transform: "translate(359.034 127.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SAGF")))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "SAGO-Default",
    "data-name": "Group 13501",
    transform: "translate(9.5 3.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Air Gap Overflow Switch"), /*#__PURE__*/React.createElement("text", {
    id: "SBAR-6",
    "data-name": "SBAR",
    transform: "translate(461.034 128.426)",
    fill: "#f1f2f2",
    fontSize: 22,
    fontFamily: "Bitstream Vera Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SBAR")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4945",
    "data-name": "Rectangle 4945",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(456.534 104.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SAGO",
    transform: "translate(469.034 127.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SAGO")))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "SAFP-Default",
    "data-name": "Group 13502",
    transform: "translate(8.5 3.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Air Filter Presence Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5002",
    "data-name": "Rectangle 5002",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(568.534 104.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SAFP",
    transform: "translate(583.034 127.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SAFP")))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "SSR-Default",
    "data-name": "Group 13498",
    transform: "translate(11.5 3.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Salt Reservoir Switch"), /*#__PURE__*/React.createElement("text", {
    id: "SBAR-7",
    "data-name": "SBAR",
    transform: "translate(125.034 128.426)",
    fill: "#f1f2f2",
    fontSize: 22,
    fontFamily: "Bitstream Vera Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SBAR")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4940",
    "data-name": "Rectangle 4940",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(121.534 104.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SSR",
    transform: "translate(141.034 127.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SSR")))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "SAGE-Default",
    "data-name": "Group 13499",
    transform: "translate(9.5 3.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Air Gap Empty Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4941",
    "data-name": "Rectangle 4941",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(234.534 104.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SAGE",
    transform: "translate(248.034 127.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SAGE")))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "SPCD-Default",
    "data-name": "Group 13505",
    transform: "translate(9.5 8.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Chemical Dosing Pump Validation Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5043",
    "data-name": "Rectangle 5043",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(345.534 166.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SPCD",
    transform: "translate(358.034 189.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SPCD")))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "SLCA-Default",
    "data-name": "Group 13506",
    transform: "translate(9.5 8.5)"
  }, /*#__PURE__*/React.createElement("title", null, "LCS Air Pressure Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5020",
    "data-name": "Rectangle 5020",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(456.534 166.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SLCA",
    transform: "translate(471.034 189.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SLCA")))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "SLCS-Default",
    "data-name": "Group 13507",
    transform: "translate(8.5 8.5)"
  }, /*#__PURE__*/React.createElement("title", null, "LCS Presence Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5021",
    "data-name": "Rectangle 5021",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(568.534 166.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SLCS",
    transform: "translate(583.034 189.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SLCS")))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "SRAL-Default",
    "data-name": "Group 13503",
    transform: "translate(11.5 8.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Rinse Aid Level Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5041",
    "data-name": "Rectangle 5041",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(121.534 166.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SRAL",
    transform: "translate(135.034 189.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SRAL")))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "SCRL-Default",
    "data-name": "Group 13504",
    transform: "translate(9.5 8.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Chemical Reservoir Level Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5042",
    "data-name": "Rectangle 5042",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(234.534 166.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SCRL",
    transform: "translate(248.034 189.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SCRL")))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "SDL-Default",
    "data-name": "Group 13508",
    transform: "translate(11.5 13.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Door Lock Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5066",
    "data-name": "Rectangle 5066",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(121.534 228.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SDL",
    transform: "translate(142.034 250.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SDL")))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "SWL-Default",
    "data-name": "Group 13509",
    transform: "translate(9.5 13.5)"
  }, /*#__PURE__*/React.createElement("title", null, "Water Leak Switch"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5067",
    "data-name": "Rectangle 5067",
    width: 75,
    height: 31,
    rx: 4,
    transform: "translate(234.534 228.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "SWL",
    transform: "translate(252.034 250.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SWL")))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "FLCD-Default",
    "data-name": "Group 13523",
    transform: "translate(10.5 11.5)"
  }, /*#__PURE__*/React.createElement("title", null, "LCD Fan"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5068",
    "data-name": "Rectangle 5068",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(567.534 325.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "FLCD",
    transform: "translate(582.034 349.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FLCD")))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "FIO-Default",
    "data-name": "Group 13524",
    transform: "translate(10.5 18.5)"
  }, /*#__PURE__*/React.createElement("title", null, "IO Board Fan"), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5069",
    "data-name": "Rectangle 5069",
    width: 75,
    height: 33,
    rx: 4,
    transform: "translate(567.534 387.926)",
    fill: "#cbd0d6",
    stroke: "#5f6a7b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "FIO",
    transform: "translate(590.034 411.426)",
    fill: "#5f6a7b",
    fontSize: 19,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FIO"))))), /*#__PURE__*/React.createElement("g", {
    id: "Key-Values",
    transform: "translate(811.487 830.33)"
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Path_5300",
    "data-name": "Path 5300",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 328.8262634277344 715.1678466796875 L 9.81571102142334 715.1678466796875 C 4.678983688354492 715.1678466796875 0.4999838769435883 710.870361328125 0.4999838769435883 705.588134765625 L 0.4999838769435883 10.07983207702637 C 0.4999838769435883 4.797468662261963 4.678983688354492 0.5000142455101013 9.81571102142334 0.5000142455101013 L 328.8262634277344 0.5000142455101013 C 333.9629821777344 0.5000142455101013 338.1419982910156 4.797468662261963 338.1419982910156 10.07983207702637 L 338.1419982910156 497.2254638671875 L 338.1419982910156 705.588134765625 C 338.1419982910156 710.870361328125 333.9629821777344 715.1678466796875 328.8262634277344 715.1678466796875 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.815704345703125 1 C 4.9547119140625 1 0.999969482421875 5.07318115234375 0.999969482421875 10.079833984375 L 0.999969482421875 705.588134765625 C 0.999969482421875 710.5946655273438 4.9547119140625 714.6678466796875 9.815704345703125 714.6678466796875 L 328.8262634277344 714.6678466796875 C 333.687255859375 714.6678466796875 337.6419982910156 710.5946655273438 337.6419982910156 705.588134765625 L 337.6419982910156 10.079833984375 C 337.6419982910156 5.07318115234375 333.687255859375 1 328.8262634277344 1 L 9.815704345703125 1 M 9.815704345703125 0 L 328.8262634277344 0 C 334.2473449707031 0 338.6419982910156 4.5128173828125 338.6419982910156 10.079833984375 C 338.6419982910156 10.079833984375 338.6419982910156 323.3482971191406 338.6419982910156 497.2254638671875 C 338.6419982910156 671.1024780273438 338.6419982910156 705.588134765625 338.6419982910156 705.588134765625 C 338.6419982910156 711.155029296875 334.2473449707031 715.6678466796875 328.8262634277344 715.6678466796875 L 9.815704345703125 715.6678466796875 C 4.394622802734375 715.6678466796875 -3.0517578125e-05 711.155029296875 -3.0517578125e-05 705.588134765625 L -3.0517578125e-05 10.079833984375 C -3.0517578125e-05 4.5128173828125 4.394622802734375 0 9.815704345703125 0 Z",
    stroke: "none",
    fill: "#57585a"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "TCH",
    transform: "translate(18.919 89.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Chamber Temperature"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TCH"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "TCH_Value",
    "data-name": 0,
    transform: "translate(141.942 89.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00.00"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "TCH_Unit",
    "data-name": "\\xBAC",
    transform: "translate(313.416 89.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19,
    y: 0
  }, "\xBAC"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "TCHV",
    transform: "translate(18.919 131.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Chamber Temperature Validation"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TCHV"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "TCHV_Value",
    "data-name": 0,
    transform: "translate(141.942 132.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00.00"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "TCHV_Unit",
    "data-name": "\\xBAC",
    transform: "translate(313.416 131.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19,
    y: 0
  }, "\xBAC"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "TDRY",
    transform: "translate(18.919 175.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Dryer Temperature"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TDRY"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "TDRY_Value",
    "data-name": 0,
    transform: "translate(141.951 176.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "000.00"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    id: "TDRY_Unit",
    "data-name": "\\xBAC",
    transform: "translate(313.416 174.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19,
    y: 0
  }, "\xBAC"))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    id: "RPMD",
    transform: "translate(18.919 218.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Dryer Motor RPM"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RPMD"))), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    id: "RPMD_Value",
    "data-name": 0,
    transform: "translate(141.947 219.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00000"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    id: "RPMD_Unit",
    transform: "translate(313.348 220.37)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -38,
    y: 0
  }, "RPM"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    id: "PTAR",
    transform: "translate(18.919 261.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Top Arm Pressure"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PTAR"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    id: "PTAR_Value",
    "data-name": 0,
    transform: "translate(141.93 261.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto",
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "000"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    id: "PTAR_Unit",
    transform: "translate(313.586 261.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto",
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -41,
    y: 0
  }, "mBar"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    id: "PBAR",
    transform: "translate(18.919 304.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Bottom Arm Pressure"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PBAR"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    id: "PBAR_Value",
    "data-name": 0,
    transform: "translate(141.93 304.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "000"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    id: "PBAR_Unit",
    "data-name": "mBar",
    transform: "translate(311.331 304.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -42,
    y: 0
  }, "mBar"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    id: "RPMT",
    transform: "translate(18.919 347.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Top Arm RPM"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RPMT"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    id: "RPMT_Value",
    "data-name": 0,
    transform: "translate(140.667 347.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    id: "RPMT_Unit",
    "data-name": "RPM",
    transform: "translate(313.348 347.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -38,
    y: 0
  }, "RPM"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    id: "RPMB",
    transform: "translate(18.919 390.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Bottom Arm RPM"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RPMB"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    id: "RPMB_Value",
    "data-name": 0,
    transform: "translate(140.667 390.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    id: "RPMB_Unit",
    "data-name": "RPM",
    transform: "translate(313.348 390.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -38,
    y: 0
  }, "RPM"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    id: "CW",
    transform: "translate(18.919 433.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Water Conductivity"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CW"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    id: "CW_Value",
    "data-name": 0,
    transform: "translate(140.67 433.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0.0"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    id: "CW_Unit",
    transform: "translate(313.857 433.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -35,
    y: 0
  }, "ppm"))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    id: "PCL",
    transform: "translate(18.919 478.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Pressure Chamber Level"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PCL"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    id: "PCL_Value",
    "data-name": 0,
    transform: "translate(141.93 478.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "000"))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    id: "PCL_Unit",
    transform: "translate(313.755 476.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -62,
    y: 0
  }, "mmH"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 10.499,
    baselineShift: -5.9994001388549805
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "O"))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    id: "CPCD",
    transform: "translate(18.919 653.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Count Pump Chemical Dosing"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CPCD"))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    id: "CPCD_Value",
    "data-name": 0,
    transform: "translate(140.667 653.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00"))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    id: "TIO",
    transform: "translate(18.919 521.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "IO Board Ambient Temperature"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TIO"))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    id: "TIO_Value",
    "data-name": 0,
    transform: "translate(141.934 520.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00.0"))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    id: "TIO_Unit",
    "data-name": "\\xBAC",
    transform: "translate(313.416 521.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19,
    y: 0
  }, "\xBAC"))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    id: "A0",
    transform: "translate(18.919 609.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "A0 (energy (time/temperature) needed for the disinfection process)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A0"))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    id: "A0_Value",
    "data-name": 0,
    transform: "translate(141.938 609.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0000"))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    id: "A0_Unit",
    "data-name": "A0",
    transform: "translate(313.162 608.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21,
    y: 0
  }, "A0"))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    id: "MLC",
    transform: "translate(18.919 695.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "ML of Chemical Dispensed"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MLC"))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    id: "MLC_Value",
    "data-name": 0,
    transform: "translate(141.93 694.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "000"))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    id: "MLC_Unit",
    transform: "translate(313.145 695.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25,
    y: 0
  }, "mL"))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    id: "TLCD",
    transform: "translate(18.919 564.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "LCD Board Temperature"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TLCD"))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    id: "TLCD_Value",
    "data-name": 0,
    transform: "translate(141.942 564.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00.00"))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    id: "TLCD_Unit",
    "data-name": "\\xBAC",
    transform: "translate(313.416 564.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19,
    y: 0
  }, "\xBAC"))), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-2",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 102.253)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-2",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-3",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 145.887)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-3",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-4",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 189.52)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-4",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-5",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 233.154)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-5",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-6",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 57.399)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-6",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    fill: "none",
    stroke: "#57585a",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10767",
    "data-name": "Group 10767",
    transform: "translate(20.068 17.203)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Key_Values",
    "data-name": "Key Values",
    transform: "translate(208.169 21)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Key Values")), /*#__PURE__*/React.createElement("g", {
    id: "Key_Value_Icon",
    "data-name": "Key Value Icon",
    transform: "translate(0 3.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5254",
    "data-name": "Path 5254",
    d: "M19.15,33.363c0-6.309,1.919-11.413,4.277-11.413s4.277,5.1,4.277,11.413",
    transform: "translate(-15.65 -21.398)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5255",
    "data-name": "Path 5255",
    d: "M34.534,30.82c0,6.309-1.919,11.413-4.277,11.413s-4.277-5.1-4.277-11.413",
    transform: "translate(-13.914 -19.168)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5256",
    "data-name": "Path 5256",
    d: "M32.7,33.463V21.51h6.535V45.34h6.4V33.175",
    transform: "translate(-12.205 -21.51)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 37.627,
    transform: "translate(0 11.915)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-7",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 276.788)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-7",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-8",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 320.422)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-8",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-9",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 364.056)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-9",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-10",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 407.69)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-10",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-11",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 451.323)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-11",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-12",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 494.957)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-12",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-13",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 538.591)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-13",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-14",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 582.225)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-14",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-15",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 624.859)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-15",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-16",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 669.493)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-16",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Key-Values-2",
    "data-name": "Key-Values",
    transform: "translate(1175.214 830.33)"
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Path_5300-2",
    "data-name": "Path 5300",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 328.8262634277344 715.712158203125 L 9.81571102142334 715.712158203125 C 4.678983688354492 715.712158203125 0.4999838769435883 711.4112548828125 0.4999838769435883 706.1248168945312 L 0.4999838769435883 10.08753395080566 C 0.4999838769435883 4.80098819732666 4.678983688354492 0.4999881982803345 9.81571102142334 0.4999881982803345 L 328.8262634277344 0.4999881982803345 C 333.9629821777344 0.4999881982803345 338.1419982910156 4.80098819732666 338.1419982910156 10.08753395080566 L 338.1419982910156 497.6035461425781 L 338.1419982910156 706.1248168945312 C 338.1419982910156 711.4112548828125 333.9629821777344 715.712158203125 328.8262634277344 715.712158203125 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.815704345703125 1 C 4.9547119140625 1 0.999969482421875 5.07659912109375 0.999969482421875 10.0875244140625 L 0.999969482421875 706.1246948242188 C 0.999969482421875 711.1355590820312 4.9547119140625 715.212158203125 9.815704345703125 715.212158203125 L 328.8262634277344 715.212158203125 C 333.687255859375 715.212158203125 337.6419982910156 711.1355590820312 337.6419982910156 706.1246948242188 L 337.6419982910156 10.0875244140625 C 337.6419982910156 5.07659912109375 333.687255859375 1 328.8262634277344 1 L 9.815704345703125 1 M 9.815704345703125 0 L 328.8262634277344 0 C 334.2473449707031 0 338.6419982910156 4.5162353515625 338.6419982910156 10.0875244140625 C 338.6419982910156 10.0875244140625 338.6419982910156 323.5941772460938 338.6419982910156 497.603515625 C 338.6419982910156 671.6127319335938 338.6419982910156 706.1246948242188 338.6419982910156 706.1246948242188 C 338.6419982910156 711.69580078125 334.2473449707031 716.212158203125 328.8262634277344 716.212158203125 L 9.815704345703125 716.212158203125 C 4.394622802734375 716.212158203125 -3.0517578125e-05 711.69580078125 -3.0517578125e-05 706.1246948242188 L -3.0517578125e-05 10.0875244140625 C -3.0517578125e-05 4.5162353515625 4.394622802734375 0 9.815704345703125 0 Z",
    stroke: "none",
    fill: "#57585a"
  }))), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    id: "PPAG",
    transform: "translate(18.239 89.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Air Gap Pump Power (%)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PPAG"))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    id: "PPAG_Value",
    "data-name": 0,
    transform: "translate(141.872 89.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0000"))), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    id: "PPAG_Unit",
    "data-name": "%",
    transform: "translate(314.494 89.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13,
    y: 0
  }, "%"))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    id: "PFIO",
    transform: "translate(18.239 133.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "IO Board Fan Power (%)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PFIO"))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    id: "PFIO_Value",
    "data-name": 0,
    transform: "translate(141.872 132.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0000"))), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    id: "PFIO_Unit",
    "data-name": "%",
    transform: "translate(314.494 132.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13,
    y: 0
  }, "%"))), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    id: "PFLC",
    transform: "translate(18.239 175.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "LCD Fan Power (%)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PFLC"))), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    id: "PFLC_Value",
    "data-name": 0,
    transform: "translate(141.872 175.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0000"))), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    id: "PFLC_Unit",
    "data-name": "%",
    transform: "translate(314.494 175.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13,
    y: 0
  }, "%"))), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    id: "PDRY",
    transform: "translate(18.239 218.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Dryer Motor Power (%)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDRY"))), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    id: "PDRY_Value",
    "data-name": 0,
    transform: "translate(141.872 218.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0000"))), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    id: "PDRY_Unit",
    "data-name": "%",
    transform: "translate(314.494 217.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13,
    y: 0
  }, "%"))), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    id: "PPCI",
    transform: "translate(18.239 262.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Circulation Pump Power (%)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PPCI"))), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    id: "PPCI_Value",
    "data-name": 0,
    transform: "translate(141.826 260.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto",
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0000"))), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    id: "PPCI_Unit",
    "data-name": "%",
    transform: "translate(314.494 260.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto",
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13,
    y: 0
  }, "%"))), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    id: "LEDR",
    transform: "translate(18.239 304.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Red LED Power (%)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "LEDR"))), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    id: "LEDR_Value",
    "data-name": 0,
    transform: "translate(141.872 303.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0000"))), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    id: "LEDR_Unit",
    "data-name": "%",
    transform: "translate(314.494 303.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13,
    y: 0
  }, "%"))), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    id: "LEDG",
    transform: "translate(18.239 347.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Green LED Power (%)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "LEDG"))), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    id: "LEDG_Value",
    "data-name": 0,
    transform: "translate(141.872 347.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0000"))), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    id: "LEDG_Unit",
    "data-name": "%",
    transform: "translate(314.494 346.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13,
    y: 0
  }, "%"))), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    id: "LEDB",
    transform: "translate(18.239 390.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Blue LED Power (%)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "LEDB"))), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    id: "LEDB_Value",
    "data-name": 0,
    transform: "translate(141.872 390.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0000"))), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    id: "LEDB_Unit",
    "data-name": "%",
    transform: "translate(314.24 391.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13,
    y: 0
  }, "%"))), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-17",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 102.054)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-17",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-18",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 148.137)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-18",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-19",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 190.137)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-19",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-20",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 233.287)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-20",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-21",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 57.399)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-21",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    fill: "none",
    stroke: "#57585a",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10767-2",
    "data-name": "Group 10767",
    transform: "translate(22.843 16.576)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PWM_Values",
    "data-name": "PWM Values",
    transform: "translate(192.809 21.627)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PWM Values")), /*#__PURE__*/React.createElement("g", {
    id: "PWM_Value_Icon",
    "data-name": "PWM Value Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_5273",
    "data-name": "Path 5273",
    transform: "translate(-11369.332 -622.799)",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11378.529,622.8h7.387l-7.07,11h8.045l-17.092,20.36,6.053-14.792h-6.52l8-16.564Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11377.330078125 622.7988891601562 L 11369.33203125 639.3628540039062 L 11375.8515625 639.3628540039062 L 11369.798828125 654.1546630859375 L 11386.890625 633.7945556640625 L 11378.845703125 633.7945556640625 L 11385.916015625 622.7988891601562 L 11377.330078125 622.7988891601562 M 11377.330078125 621.2988891601562 L 11385.916015625 621.2988891601562 C 11386.46484375 621.2988891601562 11386.9697265625 621.5985107421875 11387.232421875 622.0802001953125 C 11387.4951171875 622.5618286132812 11387.474609375 623.1486206054688 11387.177734375 623.6101684570312 L 11381.59375 632.2945556640625 L 11386.890625 632.2945556640625 C 11387.4736328125 632.2945556640625 11388.00390625 632.6323852539062 11388.25 633.1607666015625 C 11388.49609375 633.689208984375 11388.4140625 634.3124389648438 11388.0390625 634.7589721679688 L 11370.947265625 655.1190795898438 C 11370.47265625 655.685302734375 11369.6572265625 655.8207397460938 11369.0234375 655.4385986328125 C 11368.390625 655.0565185546875 11368.130859375 654.2705688476562 11368.41015625 653.5866088867188 L 11373.6171875 640.8628540039062 L 11369.33203125 640.8628540039062 C 11368.8154296875 640.8628540039062 11368.3359375 640.5974731445312 11368.0615234375 640.1602172851562 C 11367.787109375 639.7230224609375 11367.7568359375 639.1754760742188 11367.9814453125 638.7106323242188 L 11375.9794921875 622.1466674804688 C 11376.2294921875 621.6282958984375 11376.7548828125 621.2988891601562 11377.330078125 621.2988891601562 Z",
    stroke: "none",
    fill: "#5f6a7b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-22",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 277.137)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-22",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-23",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 319.137)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-23",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-24",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 362.287)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-24",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Key-Values-3",
    "data-name": "Key-Values",
    transform: "translate(1538.94 830.33)"
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Path_5300-3",
    "data-name": "Path 5300",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 328.826171875 715.712158203125 L 9.81571102142334 715.712158203125 C 4.678983688354492 715.712158203125 0.4999838769435883 711.4112548828125 0.4999838769435883 706.1248168945312 L 0.4999838769435883 10.08753395080566 C 0.4999838769435883 4.80098819732666 4.678983688354492 0.4999881982803345 9.81571102142334 0.4999881982803345 L 328.826171875 0.4999881982803345 C 333.962890625 0.4999881982803345 338.1419982910156 4.80098819732666 338.1419982910156 10.08753395080566 L 338.1419982910156 497.6035461425781 L 338.1419982910156 706.1248168945312 C 338.1419982910156 711.4112548828125 333.962890625 715.712158203125 328.826171875 715.712158203125 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.815704345703125 1 C 4.9547119140625 1 0.999969482421875 5.07659912109375 0.999969482421875 10.0875244140625 L 0.999969482421875 706.1246948242188 C 0.999969482421875 711.1355590820312 4.9547119140625 715.212158203125 9.815704345703125 715.212158203125 L 328.826171875 715.212158203125 C 333.687255859375 715.212158203125 337.6419982910156 711.1355590820312 337.6419982910156 706.1246948242188 L 337.6419982910156 10.0875244140625 C 337.6419982910156 5.07659912109375 333.687255859375 1 328.826171875 1 L 9.815704345703125 1 M 9.815704345703125 0 L 328.826171875 0 C 334.2472534179688 0 338.6419982910156 4.5162353515625 338.6419982910156 10.0875244140625 C 338.6419982910156 10.0875244140625 338.6419982910156 323.5942687988281 338.6419982910156 497.603515625 C 338.6419982910156 671.61279296875 338.6419982910156 706.1246948242188 338.6419982910156 706.1246948242188 C 338.6419982910156 711.6959228515625 334.2472534179688 716.212158203125 328.826171875 716.212158203125 L 9.815704345703125 716.212158203125 C 4.394622802734375 716.212158203125 -3.0517578125e-05 711.6959228515625 -3.0517578125e-05 706.1246948242188 L -3.0517578125e-05 10.0875244140625 C -3.0517578125e-05 4.5162353515625 4.394622802734375 0 9.815704345703125 0 Z",
    stroke: "none",
    fill: "#57585a"
  }))), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    id: "FROW",
    transform: "translate(19.06 89.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "RO Water Flow"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FROW"))), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    id: "FROW_Value",
    "data-name": 0,
    transform: "translate(141.093 89.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00"))), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    id: "FROW_Unit",
    "data-name": "L/min",
    transform: "translate(313.868 89.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -47,
    y: 0
  }, "L/min"))), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    id: "FCHW",
    transform: "translate(19.06 133.67)",
    fill: "#5f6a7b",
    fontSize: 20,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "Cold Hot Water Flow"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FCHW"))), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    id: "FCHW_Value",
    "data-name": 0,
    transform: "translate(141.093 133.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00"))), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    id: "FCHW_Unit",
    "data-name": "L/min",
    transform: "translate(313.868 133.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -47,
    y: 0
  }, "L/min"))), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    id: "FLCS",
    transform: "translate(19.06 176.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("title", null, "LCS Flow"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FLCS"))), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    id: "FLCS_Value",
    "data-name": 0,
    transform: "translate(141.093 176.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00"))), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    id: "FLCS_Unit",
    "data-name": "L/min",
    transform: "translate(313.868 176.67)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -47,
    y: 0
  }, "L/min"))), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-25",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 102.054)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-25",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-26",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 147.764)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-26",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0)",
    fill: "none",
    stroke: "#d1d3d4",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Devider-2-2-27",
    "data-name": "Devider-2-2",
    transform: "translate(16.304 67.399)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2-2-27",
    "data-name": "Line_2-2-2",
    x1: 303.271,
    transform: "translate(0 -10)",
    fill: "none",
    stroke: "#57585a",
    strokeWidth: 1,
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10767-3",
    "data-name": "Group 10767",
    transform: "translate(20.789 14.44)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Flow_Values",
    "data-name": "Flow Values",
    transform: "translate(199.625 24.763)",
    fill: "#5f6a7b",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Flow Values")), /*#__PURE__*/React.createElement("g", {
    id: "Flow_Value_Icon",
    "data-name": "Flow Value Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5249",
    "data-name": "Path 5249",
    d: "M38.765,89.718h0l-.05-.088c-.05-.1-.1-.188-.151-.276L32.444,78.33,26.336,89.342c-.063.1-.113.2-.163.3l-.05.088h0a7.061,7.061,0,1,0,12.618,0Z",
    transform: "translate(-17.213 -78.33)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5250",
    "data-name": "Path 5250",
    d: "M47.975,104.432a7.485,7.485,0,0,0-10.222,0,8.071,8.071,0,0,1-10.623,0",
    transform: "translate(-16.62 -72.603)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5251",
    "data-name": "Path 5251",
    d: "M29.192,104.432a7.485,7.485,0,0,0-10.222,0",
    transform: "translate(-18.97 -72.603)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5252",
    "data-name": "Path 5252",
    d: "M47.975,99.832a7.485,7.485,0,0,0-10.222,0,8.071,8.071,0,0,1-10.623,0",
    transform: "translate(-16.62 -73.697)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5253",
    "data-name": "Path 5253",
    d: "M29.192,99.832a7.485,7.485,0,0,0-10.222,0",
    transform: "translate(-18.97 -73.677)",
    fill: "none",
    stroke: "#5f6a7b",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWdScreen2);
export default __webpack_public_path__ + "static/media/wd_screen2.6d1ce1eec5e6169528d8ef18cd859a97.svg";
export { ForwardRef as ReactComponent };